import { render, staticRenderFns } from "./MenuItemSourcesField.vue?vue&type=template&id=20a67fe4&scoped=true&"
import script from "./MenuItemSourcesField.vue?vue&type=script&lang=js&"
export * from "./MenuItemSourcesField.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemSourcesField.vue?vue&type=style&index=0&id=20a67fe4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a67fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VTab,VTabItem,VTabs,VTextField,VTextarea})
